var site = site || {};
var generic = generic || {};

(function ($, Drupal) {
  'use strict';

  var homepageEmailSignupV3 = {
    formatter: $('.email-sms-signup-v3'),
    pc_email_optin: typeof site.userInfoCookie == 'undefined' ? 0 : parseInt(site.userInfoCookie.getValue('pc_email_optin'))
  };

  Drupal.behaviors.homepageEmailSignupV3 = {
    get: function (key) {
      return homepageEmailSignupV3[key];
    },

    set: function (key, val) {
      homepageEmailSignupV3[key] = val;
    },

    showAlternateContent: function (thisFormatter) {
      thisFormatter.find('.site-email-sms-signup__thank-you').addClass('hidden');
      thisFormatter.find('.site-email-sms-signup__form').removeClass('hidden');
      thisFormatter.find('.site-email-sms-signup__alternate').addClass('hidden');
    },

    attach: function (context, settings) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // For each instance of email signup field, listen for successful gnav
        // data results.
        // Moved here by Bloom to allow gnavdata.js to not be coupled to any
        // implementations of its data
        $(window).on('gnavdata_success', function (e, gNavData) {
          sessionStorage.email_address = '';
          if (gNavData !== null && !_.isEmpty(gNavData.EMAIL_ADDRESS)) {
            sessionStorage.email_address = gNavData.EMAIL_ADDRESS;
          }

          if (!_.isEmpty(sessionStorage.email_address)) {
            var emailField = thisFormatter.find('#form--email_sms_signup--field--PC_EMAIL_ADDRESS');

            emailField.val(sessionStorage.email_address);
          }
          $('input#form--email_sms_signup--field--PC_EMAIL_ADDRESS').focus();
        });

        if (self.get('pc_email_optin')) {
          self.showAlternateContent(thisFormatter);
        }
        // show E-mail address terms label
        if (thisFormatter.find('.form-label-email-promotions').length > 0) {
          thisFormatter.find('#form--email_sms_signup--field--PC_EMAIL_ADDRESS').focus(function () {
            thisFormatter.find('.form-label-email-promotions').slideDown(400);
          });
        }
        // show checkbox when mobile input is focused
        if (thisFormatter.find('.form-checkbox-sms-promotions').length > 0) {
          thisFormatter.find('#form--email_sms_signup--field--MOBILE_NUMBER').focus(function () {
            thisFormatter.find('.form-checkbox-sms-promotions').slideDown(400);
          });
        }

        // handle user submitting the email/sms form
        thisFormatter.find('form').submit(function (submitEvt) {
          submitEvt.preventDefault();

          var params = {};

          $.each(thisFormatter.find('form').serializeArray(), function (index, kv) {
            params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
          });
          // console.log(params);

          // handle the sms_promotions checkbox - if its checked its being read as 'on' when serialized
          // we need a boolean value
          if (thisFormatter.find('form').find('input[name="SMS_PROMOTIONS"]').prop('checked')) {
            params.SMS_PROMOTIONS = 1;
          }

          var trackSource = thisFormatter.find('form').find('input[name="ORIGINAL_SOURCE"]')[0].value;

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [params],
            onSuccess: function (result) {
              // var results = result.getData();
              thisFormatter.find('.site-email-sms-signup__form').fadeOut(400, function () {
                $(this).addClass('hidden');
                thisFormatter.find('.site-email-sms-signup__thank-you').removeClass('hidden');
              });
              site.track.evtLink({
                event_name: 'newsletter_signup',
                event_category: trackSource,
                event_action: 'signin',
                event_label: 'signin'
              });
            },
            onFailure: function (result) {
              // console.log(result.getMessages());
              var errorObjectsArray = result.getMessages();

              generic.showErrors(errorObjectsArray, thisFormatter.find('.error_messages'), null);
              site.track.evtLink({
                event_name: 'newsletter_signup',
                event_category: trackSource,
                event_action: 'failure',
                event_label: 'failure'
              });
            }
          });
        });
      });
      if (Drupal.settings.globals_variables.gdpr_compliant) {
        var infomessagebox = function remInfoMessageBox() {
          if ($('#info-message-box').get(0)) {
            $('#info-message-box').remove();
          }
          if ($('#infoArrowBefore').get(0)) {
            $('#infoArrowBefore').remove();
          }
        };
        $('#cboxClose, #info-close').on('mousedown', function() {
          infomessagebox();
        });
      }
    },

    attached: false
  };
})(jQuery, Drupal);
